import React from 'react';
import { Route } from 'react-router-dom';
import { RestrictedRedirect } from '../components/RestrictedRedirect';
import { ProjectsPage } from '../pages/projects/ProjectsPage';
import { ProjectDetailPage } from '../pages/projects/ProjectDetailPage';
import { KanbanPage } from '../pages/projects/KanbanPage';
import { GanttPage } from '../pages/projects/GanttPage';
import { PlanPage } from '../pages/projects/PlanPage';
import { StatusReportPage } from '../pages/projects/StatusReportPage';
import { TimeMachinePage } from '../pages/projects/TimeMachinePage';
import { TaskDetailPage } from '../pages/projects/TaskDetailPage';
import { DeletedProjectsPage } from '../pages/projects/DeletedProjectsPage';
import { LegacyRedirect } from './LegacyRedirect';

/** Project and task routes. Rendered inside ProtectedRoute › Layout. */
export const projectRoutes = (
    <>
        {/* PM: Projects — restricted users keep the project
            overview + tasks, but the advanced sub-views are
            URL-blocked to match the hidden project tabs. */}
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/projects/:id" element={<ProjectDetailPage />} />
        <Route element={<RestrictedRedirect />}>
            {/* GET /projects/deleted is not restriction-scoped; keep restricted users out. */}
            <Route path="/projects/deleted" element={<DeletedProjectsPage />} />
            <Route path="/projects/:id/board" element={<KanbanPage />} />
            <Route path="/projects/:id/timeline" element={<GanttPage />} />
            <Route path="/projects/:id/plan" element={<PlanPage />} />
            {/* Was a standalone AIPilot with an empty project name; the
                co-pilot lives in the project shell's Project tools › AI. */}
            <Route path="/projects/:id/ai" element={<LegacyRedirect to="/projects/:id" set={{ tab: 'Tools', view: 'ai' }} />} />
            <Route path="/projects/:id/report" element={<StatusReportPage />} />
            <Route path="/projects/:id/time-machine" element={<TimeMachinePage />} />
        </Route>

        {/* PM: Tasks */}
        <Route path="/tasks/:id" element={<TaskDetailPage />} />
    </>
);

